<style>
  .jl{
    margin-left: 10px;
  }
</style>
<template>
  <el-row>
    <table-template :queryParams="queryParams" @onDataFilter="onDataFilter"  actionUrl="/distributor/findPlatIncomeAndExpendDetailList.action"
                    ref="platIncomeAndExpendDetailTable">
      <template slot="search">
        <el-row :gutter="6">

          <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
          </el-date-picker>

          <el-select class="jl" v-model="queryParams.moduleType" clearable @change="$refs.platIncomeAndExpendDetailTable.search()" filterable placeholder="请选择业务类型">

            <el-option :value="1" label="开通会员"></el-option>
            <el-option :value="2" label="会员续费"></el-option>
            <el-option :value="3" label="升级经纪人"></el-option>
            <el-option :value="4" label="购买云服务"></el-option>
            <el-option :value="7" label="商品活动"></el-option>
            <el-option :value="8" label="智联车保"></el-option>
            <el-option :value="9" label="商家订单"></el-option>
            <el-option :value="10" label="云豆充值"></el-option>
            <el-option :value="11" label="省心加油"></el-option>
            <el-option :value="12" label="商家提现"></el-option>
            <el-option :value="13" label="经纪人提现"></el-option>
            <el-option :value="20" label="帖子置顶"></el-option>
            <el-option :value="21" label="二手车发布"></el-option>
            <el-option :value="22" label="二手车置顶"></el-option>
            <el-option :value="23" label="维保查询"></el-option>
            <el-option :value="24" label="碰撞查询"></el-option>
          </el-select>

          <el-input class="jl" style="width:310px;"  placeholder="订单号" v-model="queryParams.keyWord"></el-input>

          <el-button  @click="$refs.platIncomeAndExpendDetailTable.search()" type="primary">搜索</el-button>

        </el-row>
        <el-row :gutter="5">
          <el-divider></el-divider>
         <el-col :span="4"><span style="color: #67C23A">收入：{{ sumIncomeData.sumTotalMoney/100 }}元,{{sumIncomeData.totalCount}}笔</span></el-col>
         <el-col :span="4"><span style="color: #F56C6C">支出：{{ sumExpendData.sumTotalMoney/100 }}元,{{sumExpendData.totalCount}}笔</span></el-col>

        </el-row>
      </template>
      <template slot="item">
        <el-table-column
            label="记账时间"
            prop="payTime">
          <template scope="scope">
            {{scope.row.payTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
            label="业务订单号"
            prop="payNumber">
        </el-table-column>
        <el-table-column
            label="业务类型"
            prop="moduleType">
          <template scope="scope">
            <span>{{scope.row.moduleType|moduleTypeFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="记账类型"
            prop="moneyType">
          <template scope="scope">
            <span>{{scope.row.moneyType|moneyTypeFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="收支金额"
            prop="totalMoney">
          <template scope="scope">
            <span v-if="scope.row.moneyType==1" style="color: #67C23A">+{{scope.row.totalMoney/100}}</span>
            <span v-else style="color: #F56C6C">-{{scope.row.totalMoney/100}}</span>
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'platIncomeAndExpendDetail',
  data: function () {
    return {
      queryParams: {},
      sumExpendData: {
        sumTotalMoney: 0,
        totalCount: 0
      },
      sumIncomeData: {
        sumTotalMoney: 0,
        totalCount: 0
      }
    }
  },
  methods: {
    onDataFilter: function (dataInfo) {
      this.sumExpendData = dataInfo.sumExpendData
      this.sumIncomeData = dataInfo.sumIncomeData
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.platIncomeAndExpendDetailTable.search()
    }
  },

  filters: {
    moduleTypeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 开通会员
          filterValue = '开通会员'
          break
        case 2:// 会员续费
          filterValue = '会员续费'
          break
        case 3:// 购买权益卡礼包
          filterValue = '升级经纪人'
          break
        case 4:// 续补权益卡
          filterValue = '购买云服务'
          break
        case 5:// 维保查询
          filterValue = '维保查询'
          break
        case 6:// 碰撞查询
          filterValue = '碰撞查询'
          break
        case 7:// 商品活动
          filterValue = '商品活动'
          break
        case 8:// 智联订单
          filterValue = '智联车保'
          break
        case 9:// 商品订单
          filterValue = '商品订单'
          break
        case 10:// 云豆充值
          filterValue = '云豆充值'
          break
        case 11:// 省心加油
          filterValue = '省心加油'
          break
        case 12:// 商家提现
          filterValue = '商家提现'
          break
        case 13:// 经纪人提现
          filterValue = '经纪人提现'
          break
        case 20:// 经纪人提现
          filterValue = '帖子置顶'
          break
        case 21:// 经纪人提现
          filterValue = '二手车发布'
          break
        case 22:// 经纪人提现
          filterValue = '二手车置顶'
          break
        case 23:// 经纪人提现
          filterValue = '维保查询'
          break
        case 24:// 经纪人提现
          filterValue = '碰撞查询'
          break
      }
      return filterValue
    },
    moneyTypeFilter (val) {
      let filterValue = '暂无'
      switch (val) {
        case 1:
          filterValue = '收入'
          break
        case 2:
          filterValue = '支出'
          break
      }
      return filterValue
    }
  }
}
</script>

<style scoped>
</style>
